import React from 'react';
import { PercentCircle, Users, Star, Sparkles } from 'lucide-react';

/**
 * Компонент раздела с льготами
 */
const DiscountSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  discountTypes
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-center mb-3">
        <label className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer">
          <input
            type="checkbox"
            name="hasDiscount"
            checked={formData.hasDiscount}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 flex items-center">
            <PercentCircle className="w-5 h-5 mr-1 text-purple-500" />
            Учитывать льготы и скидки
          </span>
        </label>
      </div>

      {formData.hasDiscount && (
        <div className="bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
            {/* Тип льготы */}
            <div>
              <label htmlFor="discountType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Тип льготы
              </label>
              <select
                id="discountType"
                name="discountType"
                value={formData.discountType}
                onChange={handleInputChange}
                className="form-select w-full"
              >
                {discountTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name} ({type.percent}%)
                  </option>
                ))}
              </select>
            </div>

            {/* Процент льготы */}
            <div>
              <label htmlFor="discountPercent" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Процент льготы (%)
              </label>
              <input
                type="text"
                id="discountPercent"
                name="discountPercent"
                value={formData.discountPercent}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.discountPercent ? 'input-error' : ''}`}
                placeholder="50"
              />
              {errors.discountPercent && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.discountPercent}
                </p>
              )}
            </div>
          </div>

          {/* Информация о льготах */}
          <div className="bg-white dark:bg-gray-800 p-3 rounded-lg border border-purple-100 dark:border-purple-900/50">
            <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-2 flex items-center">
              <Sparkles className="w-4 h-4 mr-1" />
              Информация о льготах в России
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs">
              <div className="p-2 bg-purple-50 dark:bg-purple-900/20 rounded border border-purple-100 dark:border-purple-900/50 flex items-start">
                <Users className="w-4 h-4 text-purple-500 mr-2 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-purple-700 dark:text-purple-300">Многодетные семьи</p>
                  <p className="text-purple-600 dark:text-purple-400">Скидка 30-50% на оплату коммунальных услуг</p>
                </div>
              </div>
              <div className="p-2 bg-purple-50 dark:bg-purple-900/20 rounded border border-purple-100 dark:border-purple-900/50 flex items-start">
                <Star className="w-4 h-4 text-purple-500 mr-2 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-purple-700 dark:text-purple-300">Ветераны и инвалиды</p>
                  <p className="text-purple-600 dark:text-purple-400">Скидка 50% в пределах социальной нормы потребления</p>
                </div>
              </div>
              <div className="sm:col-span-2 p-2 bg-purple-50 dark:bg-purple-900/20 rounded border border-purple-100 dark:border-purple-900/50">
                <p className="text-purple-700 dark:text-purple-300 font-medium">❗ Важно</p>
                <p className="text-purple-600 dark:text-purple-400">Льготы предоставляются в соответствии с законодательством региона. Для получения точной информации обратитесь в органы социальной защиты.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DiscountSection;